import { Flexbox } from "st-app";
import { GroupAction } from "./GroupAction";
import { Group } from "./Group";

import styles from '../sis-role-dashboard.module.css'
import { UserSuggestions } from "./UserSuggestions";
import { UserRecentHistory } from "./UserRecentHistory";
import { requireRoleDashboardContext } from "../RoleDashboardContext";
import { For, createMemo } from "solid-js";
import { RoleActionDescriptor, StaffRole } from "../../../api";

export function CounselorDashboard() {
    const ctx = requireRoleDashboardContext();

    const tasks = ctx.sortedActions([
        'Counselor.GradCheck',
        'Counselor.ESRRequest',
        'K12.LoginStudent',
        'K12.LoginParent',
        'K12.LocateStudent',
        'K12.ContactStudent',
    ]);

    const shortcuts = createMemo(() => {
        const addShortcuts = ctx.configuration()
            ?.additionalShortcuts
            .filter(desc => desc.role === StaffRole.Counselor)
            .map(desc => desc.ID!);

        return ctx.sortedActions([
            'K12.PersonSearch',
            'Counselor.AddCourseHistory',
            'Counselor.WalkInSched',
            'Counselor.SchedReq',
            'Counselor.StudentConf',
            'Counselor.StudentCheckIn',
            'Counselor.CounselorAssignment',
            'Counselor.CareerPlan',
            'Counselor.SchedControl',
            'Counselor.HallPassAdmin',
        ].concat(addShortcuts ?? []));
    });

    return <Flexbox dir="horizontal" auto class={styles['dashboard-content']} >
        <Flexbox dir="vertical" auto>
            <Group title="Tasks" icon="fas fa-graduation-cap" color="--header-green">
                <For each={tasks}>{id => <GroupAction id={id} />}</For>
            </Group>

            <Group title="Shortcuts" icon="fas fa-info-circle" color="--header-blue">
                <For each={shortcuts()}>{id => <GroupAction id={id} allowDetach />}</For>
            </Group>

            <UserSuggestions />

            <Flexbox.Item auto />
        </Flexbox>

        <UserRecentHistory />
    </Flexbox>
}

